import printerMixin from "@/modules/printManager/PrinterMixin";
export default {
  mixins: [printerMixin],
  methods: {
    tableTransfer(ticket_name, lineId, item_number, action) {
      // console.log(item);
      let url =
        this.$apiURL +
        "sale/" +
        ticket_name +
        "/kds/" +
        lineId +
        "/confirm_table_transfer";

      let params = {
        store_id: localStorage.getItem("storeId"),
        user_id: localStorage.getItem("userId"),
        node_id: localStorage.getItem("nodeId"),
        item_number: item_number,
        action: action,
      };

      this.$http
        .post(url, params)
        .then(function(resp) {
          console.log(resp);
        })
        .catch(function(failure) {
          let msg = failure.body.message || "Error";
          this.$store.commit("showSnackbar", {
            message: msg,
            color: "error",
          });
        });
    },
    setMultipleItemStatus(ticket_name, lineId, itemIds, status) {
      // console.log(item);
      let url =
        this.$apiURL +
        "sale/" +
        ticket_name +
        "/kds/" +
        lineId +
        "/status_change/" +
        status +
        "/multipleItems";

      let params = {
        store_id: localStorage.getItem("storeId"),
        user_id: localStorage.getItem("userId"),
        node_id: localStorage.getItem("nodeId"),
        items: itemIds
      };

      this.$http
        .put(url, params)
        .then(function(resp) {
          console.log(resp);
          this.callPrinter(resp.body.print_data);
        })
        .catch(function(failure) {
          let msg = failure.body.message || "Error";
          this.$store.commit("showSnackbar", {
            message: msg,
            color: "error"
          });
        });
    },
    // Shared by every view that can change an item's status (grid and list),
    // so the partial-ready affordance appears under the same conditions in both.
    isItemReady(item) {
      return item.status == 4 || item.status == 6;
    },
    // Only an outstanding line with more than one portion has a quantity worth
    // asking about. A single portion is already covered by the row's own green
    // Food Ready button.
    canPickQuantity(item) {
      return (
        Number(item.quantity) > 1 && !this.isItemReady(item) && item.status != 9
      );
    },
    // The engine splits a partially-ready line into a prepared row and a
    // remainder row that share a ticket, KOT and menu item. Regrouping them
    // recovers how much of the original line is done.
    readyTally(item, siblings) {
      const groupKey = (i) =>
        `${i.ticket_name || ""}-${i.kot_number}-${i.menu_id}-${i.serving_size_id}`;
      const key = groupKey(item);
      let ready = 0;
      let total = 0;

      (siblings || []).forEach((sibling) => {
        if (groupKey(sibling) !== key || sibling.status == 9) return;
        const qty = Number(sibling.quantity) || 0;
        total += qty;
        if (this.isItemReady(sibling)) ready += qty;
      });

      return { ready, total };
    },
    // "5/19" on the outstanding row: how many of the original line are ready.
    // Empty while nothing is done, so untouched rows stay exactly as they were.
    readyProgress(item, siblings) {
      if (this.isItemReady(item)) return "";
      const { ready, total } = this.readyTally(item, siblings);
      return ready > 0 && ready < total ? `${ready}/${total}` : "";
    },
    // Tapping the quantity is the ONLY route into the partial dialog. It does
    // not go through act(), so every existing action button -- Food Ready, Void,
    // Accept, Serve, call-back -- still fires immediately exactly as before.
    onQtyClick(evt, item) {
      if (!this.canPickQuantity(item)) return;
      evt.stopPropagation();
      this.qtyPickerItem = item;
      this.qtyPickerStatus = 4;
      this.showQtyPicker = true;
    },
    // check.vue items carry `name`; the list view's rows carry `menu_name`.
    itemLabel(item) {
      return (item && (item.name || item.menu_name)) || "item";
    },
    // A partial quantity is only meaningful when it is a whole number strictly
    // between 0 and the item's own quantity. Anything else (undefined, the full
    // quantity, junk) means "the whole line" and must leave the URL untouched so
    // every existing caller keeps hitting the original route.
    isPartialQuantity(quantity, item) {
      let qty = Number(quantity);
      return (
        Number.isInteger(qty) && qty > 0 && qty < Number(item && item.quantity)
      );
    },
    setItemStatus(
      ticket_name,
      lineId,
      item,
      status,
      call_back_item,
      serveItem,
      quantity
    ) {
      // console.log(item);
      let url =
        this.$apiURL +
        "sale/" +
        ticket_name +
        "/kds/" +
        lineId +
        "/item/" +
        item.item_number +
        "/status_change/" +
        status;

      // The engine has no /call_back_item/quantity route, so the two are exclusive.
      let isPartial = !call_back_item && this.isPartialQuantity(quantity, item);
      if (call_back_item) {
        url += "/call_back_item";
      } else if (isPartial) {
        url += "/quantity/" + Number(quantity);
      }
      if (serveItem) {
        url = this.$apiURL + "sale/" + ticket_name + "/serveItem";
        isPartial = false;
      }
      // A partial split silently turns one row into two, so say what happened.
      let partialMessage = isPartial
        ? `${Number(quantity)} of ${item.quantity} ${this.itemLabel(item)} ` +
          `marked ready, ${item.quantity - Number(quantity)} still cooking`
        : "";
      // console.log(url);
      let params = {
        store_id: localStorage.getItem("storeId"),
        user_id: localStorage.getItem("userId"),
        node_id: localStorage.getItem("nodeId"),
        item_number: item.item_number
      };

      this.$http
        .put(url, params)
        .then(function(resp) {
          console.log(resp);
          this.callPrinter(resp.body.print_data);
          if (partialMessage) {
            this.$store.commit("showSnackbar", {
              message: partialMessage,
              color: "success"
            });
          }
        })
        .catch(function(failure) {
          let msg = failure.body.message || "Error";
          this.$store.commit("showSnackbar", {
            message: msg,
            color: "error"
          });
        });
    },
    setAutoAccept(check, lineId) {
      let url =
        this.$apiURL +
        "/sale/" +
        check.ticket_name +
        "/kds/" +
        lineId +
        "/auto_accept";

      let params = {
        store_id: localStorage.getItem("storeId"),
        user_id: localStorage.getItem("userId"),
        node_id: localStorage.getItem("nodeId")
      };

      this.$http
        .put(url, params)
        .then(function() {
          // console.log(resp);
        })
        .catch(function(failure) {
          // console.log(failure)
          let msg = failure.body.message || "Error";
          this.$store.commit("showSnackbar", {
            message: msg,
            color: "error"
          });
        });
    },
    setCheckStatus(check, lineId, status, kotNo) {
      console.log({ check });
      let url =
        this.$apiURL +
        "/sale/" +
        check.ticket_name +
        "/kds/" +
        lineId +
        "/status_change/" +
        status;

      if (kotNo) {
        url += "/kot_number/" + check.kot_number;
      }

      let params = {
        store_id: localStorage.getItem("storeId"),
        user_id: localStorage.getItem("userId"),
        node_id: localStorage.getItem("nodeId")
      };

      this.$http
        .put(url, params)
        .then(function(resp) {
          console.log(resp);
          this.callPrinter(resp.body.print_data);
        })
        .catch(function(failure) {
          // console.log(failure)
          let msg = failure.body.message || "Error";
          this.$store.commit("showSnackbar", {
            message: msg,
            color: "error"
          });
        });
    },
    getMasters() {
      this.getCuisines();
      this.getCategories();
    },
    getCuisines() {
      this.$http
        .get(`${this.$apiURL}store/${localStorage.getItem("storeId")}/cuisines`)
        .then(function(resp) {
          this.$store.commit("setCuisines", resp.body.cuisines);
        })
        .catch(function() {});
    },
    getCategories() {
      this.$http
        .get(
          `${this.$apiURL}store/${localStorage.getItem("storeId")}/categories`
        )
        .then(function(resp) {
          this.$store.commit("setCategories", resp.body.categories);
        })
        .catch(function() {});
    },
    selectedModifiers(modifier_receipe) {
      let modifiers = [];
      // console.log({ modifier_receipe });
      if (!modifier_receipe) {
        return modifiers;
      }

      if (Array.isArray(modifier_receipe.mandatory_modifier_groups)) {
        modifier_receipe.mandatory_modifier_groups.some((group) => {
          group.modifiers.some((modifier) => {
            modifiers.push(modifier);
          });
        });
      }

      if (Array.isArray(modifier_receipe.optional_modifier_groups)) {
        modifier_receipe.optional_modifier_groups.some((group) => {
          group.modifiers.some((modifier) => {
            modifiers.push(modifier);
          });
        });
      }
      // console.log(modifiers);
      return modifiers;
    },
    deletedIncludedModifiers(modifier_receipe) {
      return modifier_receipe &&
        Array.isArray(modifier_receipe.deleted_included_modifiers)
        ? modifier_receipe.deleted_included_modifiers
        : [];
    }
  }
};
